import { PortableText } from "@portabletext/react";
import React from "react";
import Button from "../Button";
import { GatsbyImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

export default function BuilderContent({ data, product, enable = false }) {
  return (
    <section className="py-[64px]">
      <div className="mx-auto px-[16px] sm:px-[24px] lg:px-[32px]">
        <div className="flex flex-col  gap-12">
          <div className="space-y-6">
            {data.heading && (
              <h2
                className="text-[30px] sm:text-[36px] font-bold"
                style={{
                  color: data?.headingColor?.hex ?? "inherit",
                }}
              >
                {data.heading}
              </h2>
            )}
            {/* {subtitle && ( */}
            {data.subheading && (
              <h3
                className="text-[20px] sm:text-[24px] font-semibold mt-[20px]"
                style={{
                  color: data?.subheadingColor?.hex ?? "inherit",
                }}
              >
                {data.subheading}
              </h3>
            )}
            {/* {enable && product?.sku && <BuilderProduct product={product} />} */}
            {/* )} */}
            <div className="post-content mt-40">
              {data._rawDescription && (
                <div
                  // className="text-[18px] richtext whitespace-pre-wrap wysiwyg wysiwyg-strong:font-bold wysiwyg-li:leading-normal"
                  style={{
                    color: data?.descriptionColor?.hex ?? "inherit",
                  }}
                >
                  <PortableText
                    value={data._rawDescription}
                    components={{
                      types: {
                        table: ({ children, value }) => {
                          return (
                            <table className="table table-auto my-5 border-separate border-spacing-3">
                              <tbody>
                                {value.rows.map((row) => (
                                  <tr key={row._key}>
                                    {row.cells.map((cell, key) => (
                                      <td
                                        className={`border border-slate-600 border-solid ${
                                          key === 0 ? "font-bold" : ""
                                        }`}
                                        key={key}
                                      >
                                        {cell}
                                      </td>
                                    ))}
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          );
                        },
                      },
                      marks: {
                        sectionId: ({ children, value }) => (
                          <span id={value.id || undefined}>{children}</span>
                        ),
                        link: ({ children, value }) => (
                          <a href={value.href} target="_blank">
                            {children}
                          </a>
                        ),
                        slug: ({ children, value }) => {
                          return (
                            <Link
                              to={
                                value.current.startsWith("/")
                                  ? value.current
                                  : `/${value.current}`
                              }
                            >
                              {children}
                            </Link>
                          );
                        },
                      },
                    }}
                  />
                </div>
              )}
            </div>
            {data.button?.title && (
              <div className="mt-80">
                <Button
                  text={data.button.title}
                  btnType={data.button.btnType}
                  link={data.button.link}
                  linkType={data.button.linkType}
                  border="bordered-black"
                />
              </div>
            )}
          </div>

          {data.image && (
            <div className="max-w-5xl relative w-full h-full aspect-square">
              <GatsbyImage
                src={data.image.iconImage.asset.gatsbyImageData}
                alt={data.image.title}
                loading="eager"
                objectFit="contain"
                className="object-contain w-full h-full"
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
